import { useRouter } from "next/router";
import { useEffect } from "react";
import NProgress from "nprogress";

export function useNavigationProgress() {
  const router = useRouter();

  useEffect(() => {
    NProgress.configure({ showSpinner: false });
  }, []);

  useEffect(() => {
    const handleStart = (url: string) =>
      url !== router.asPath && NProgress.start();
    const handleComplete = () => NProgress.done(true);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [router.asPath]);

  return {};
}
